const getDataOrg = () => {
  return [
    {
      id: 1,
      name: "FKHMEI",
      text: "Forum Komunikasi HME Indonesia",
      position: "Kordinator Daerah Lampung",
      year: "Oct 2021 - Apr 2022",
    },
    {
      id: 2,
      name: "Himatro",
      text: "Himpunan Mahasiswa Elektro Unila",
      position: "Pengurus Divisi Sosial Wirausaha",
      year: "Aug 2021 - Dec 2022",
    },
    {
      id: 3,
      name: "BEM Unila",
      text: "Badan Eksekutif Mahasiswa Unila",
      position: "Korps Muda BEM",
      year: "Aug 2020 - Mar 2021",
    },
  ];
};

export { getDataOrg };
